export default __webpack_public_path__ + "static/media/collect-XP.3500ed09.mp3";